import { render } from "./InventoryWeb.vue?vue&type=template&id=6b9cd362&scoped=true"
import script from "./InventoryWeb.vue?vue&type=script&lang=js"
export * from "./InventoryWeb.vue?vue&type=script&lang=js"

import "./InventoryWeb.vue?vue&type=style&index=0&id=6b9cd362&lang=scss&scoped=true"
import "./InventoryWeb.vue?vue&type=style&index=1&id=6b9cd362&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b9cd362"

export default script